export default "__VITE_ASSET__23acccd4__"